import script from "./NewRequestModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewRequestModal.vue?vue&type=script&setup=true&lang=js"

import "./NewRequestModal.vue?vue&type=style&index=0&id=56663216&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56663216"]])

export default __exports__